import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/idac")({
  loader: async () => {
    const page = await loadStandalonePage({ data: { path: "idac.md" } });
    return {
      title: (page.title as string) || "",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      featured_image: page.featured_image as string | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || loaderData?.title,
      description: loaderData?.seo_description,
      image: loaderData?.featured_image,
      url: "/idac",
    }),
    links: seoLinks({ url: "/idac" }),
  }),
  component: IdacPage,
});

function IdacPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
